import { createSlice, PayloadAction } from '@reduxjs/toolkit';

type UploadedDataState = {
  selectedImportOperationId?: number;
};

const initialState: UploadedDataState = {
  selectedImportOperationId: undefined,
};

const uploadedDataSlice = createSlice({
  name: 'uploadedData',
  initialState,
  reducers: {
    setSelectedImportOperationId(state, action: PayloadAction<number>) {
      state.selectedImportOperationId = action.payload;
    },
    clearSelectedImportOperationId(state) {
      state.selectedImportOperationId = undefined;
    },
  },
});

export const { setSelectedImportOperationId, clearSelectedImportOperationId } = uploadedDataSlice.actions;

export default uploadedDataSlice.reducer;
